import script from "./GoToHoloFuelModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GoToHoloFuelModal.vue?vue&type=script&setup=true&lang=js"

import "./GoToHoloFuelModal.vue?vue&type=style&index=0&id=4ffb0031&scoped=true&lang=scss"
script.__scopeId = "data-v-4ffb0031"

export default script